import { ALL_CAT_NAME, CATEGORIES_PLAIN, PHOTO_TYPE } from 'site-modules/shared/constants/photoflipper/photoflipper';

export const PHOTO_ROW_THRESHOLD = 4;
export const OVERLAY_TYPE = { REST_PHOTOS: 'rest-photos' };

export function getPhotoflipperProps({
  photoNum,
  params,
  altMedia,
  category = ALL_CAT_NAME,
  isPreprod,
  is360Tab,
  isCore6981Test,
}) {
  const { make, model, year, submodel } = params;

  return {
    makeSlug: make,
    modelSlug: model,
    year,
    submodel,
    initialMediaType: PHOTO_TYPE,
    show360Photos: true,
    galleryPfOptions: {
      ...(isPreprod ? { altMedia } : {}),
      pageNum: 1,
      selectedCategory: is360Tab ? CATEGORIES_PLAIN.PHOTOS_360 : category,
      gallerySubmodel: submodel,
      currentSlide: photoNum,
      isGalleryPf: true,
    },
    isPreprod,
    isCore6981Test,
  };
}
